module.exports = __webpack_public_path__ + "static/media/logo.3795f66d.png";